import { svg } from '@phi/components';
import raw from './pro-indicator.inline.svg';
import { VNode } from 'vue';

export const pro_indicator = (): VNode => svg(raw);
